/**
 * Course Date Filter
 *
 * On course product pages (product.course-product template):
 *  - Pre-fetches all variants from /products/{handle}.js on page load
 *  - On location change: applies date availability synchronously from the
 *    cache and clicks the first available date — no network round-trip needed.
 *    Because the click fires synchronously, product-info.js's abort controller
 *    kills any in-flight (location, old-date) fetch immediately, leaving only
 *    one fetch: (location, first-date). Single DOM update, no jank.
 *  - Falls back to a section fetch if the cache isn't ready yet (edge case:
 *    first interaction before the .js fetch resolves).
 *
 * Depends on: FoxTheme.pubsub
 */
(function () {

  var vs = document.querySelector('variant-selects');
  if (!vs) return;

  var sectionId  = vs.dataset.section;
  var productUrl = vs.dataset.url;
  if (!sectionId || !productUrl) return;

  /* Build location name → option_value_id map once at init (IDs are stable) */
  var locationOptionValueIds = {};
  vs.querySelectorAll('fieldset').forEach(function (fs) {
    var legend = fs.querySelector('legend');
    if (!legend || !legend.textContent.toLowerCase().includes('location')) return;
    fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.dataset.optionValueId) {
        locationOptionValueIds[input.value] = input.dataset.optionValueId;
      }
    });
  });

  /* Variant cache — loaded once on page load from /products/{handle}.js */
  var variantsCache = null;
  var locationOptKey = 'option1';
  var dateOptKey     = 'option2';

  fetch(productUrl + '.js')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      (data.options || []).forEach(function (name, i) {
        var lower = name.toLowerCase();
        if (lower === 'location') locationOptKey = 'option' + (i + 1);
        if (lower === 'date')     dateOptKey     = 'option' + (i + 1);
      });
      variantsCache = data.variants || [];
    })
    .catch(function () {});

  /* Always re-query live DOM — product-info.js replaces <variant-selects> on every change */
  function getDateFieldset() {
    var liveVs = document.querySelector('variant-selects');
    if (!liveVs) return null;
    var found = null;
    liveVs.querySelectorAll('fieldset').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && legend.textContent.toLowerCase().includes('date')) found = fs;
    });
    return found;
  }

  function selectFirstAvailableDate() {
    var dateFs = getDateFieldset();
    if (!dateFs) return;
    var first = dateFs.querySelector('input[type="radio"]:not(.disabled)');
    if (first) first.click();
  }

  /* Cache hit path — synchronous, no fetch */
  function applyFromCache(locationValue) {
    var dateFs = getDateFieldset();
    if (!dateFs) return;
    dateFs.querySelectorAll('input[type="radio"]').forEach(function (input) {
      var ok = variantsCache.some(function (v) {
        return v[locationOptKey] === locationValue &&
               v[dateOptKey]     === input.value  &&
               v.available;
      });
      input.classList.toggle('disabled', !ok);
    });
    selectFirstAvailableDate();
  }

  /* Cache miss fallback — section fetch (same as previous approach) */
  function applyFromSectionFetch(locationValue) {
    var optionValueId = locationOptionValueIds[locationValue];
    if (!optionValueId) { selectFirstAvailableDate(); return; }

    var url = productUrl + '?option_values=' + optionValueId + '&section_id=' + sectionId;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var srcDateFs = null;
        doc.querySelectorAll('fieldset').forEach(function (fs) {
          var legend = fs.querySelector('legend');
          if (legend && legend.textContent.toLowerCase().includes('date')) srcDateFs = fs;
        });
        if (srcDateFs) {
          var liveDateFs = getDateFieldset();
          if (liveDateFs) {
            liveDateFs.querySelectorAll('input[type="radio"]').forEach(function (liveInput) {
              var escaped = liveInput.value.replace(/"/g, '\\"');
              var srcInput = srcDateFs.querySelector('input[value="' + escaped + '"]');
              liveInput.classList.toggle('disabled', !srcInput || srcInput.classList.contains('disabled'));
            });
          }
        }
      })
      .catch(function () {})
      .finally(function () {
        selectFirstAvailableDate();
      });
  }

  FoxTheme.pubsub.subscribe(
    FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
    function (payload) {
      var target = payload && payload.data && payload.data.target;
      if (!target) return;
      var fs     = target.closest && target.closest('fieldset');
      var legend = fs && fs.querySelector('legend');
      if (!legend || !legend.textContent.toLowerCase().includes('location')) return;

      if (variantsCache) {
        applyFromCache(target.value);        /* synchronous — one fetch total */
      } else {
        applyFromSectionFetch(target.value); /* fallback — two fetches, first cold load only */
      }
    }
  );

})();
